import React from 'react'

const Pembayaran = ({nik="", amount="", dataIuran={}, periode=1, kodeIuran="", program=""}) => {
  const selectedProgram = `JKK,JKM,${program}`
  const dataIuranKeys = Object.keys(dataIuran)
  const emptyArray = new Array(3)
  
  const items = dataIuranKeys.reduce((arr, key) => {
    const re = /^[^:]*/g
    switch (key) {
      case "PROG_JKK":
        arr[0] = ["JKK", re.exec(dataIuran[key])[0], periode]
        break
      case "PROG_JKM":
        arr[1] = ["JKM", re.exec(dataIuran[key])[0], periode]
        break
      case "PROG_JHT":
        arr[2] = ["JHT", re.exec(dataIuran[key])[0], periode]
        break
    }
    return arr
  }, emptyArray)
  console.log(items)
  const paramExample = {
    "invoice":"3671061508810006",
    "amount":36800,
    "items":[["JKK",10000,1],["JKM",6800,1],["JHT",20000,1]],
    "program":"JKK,JKM,JHT",
    "periode":1,
    "kode_iuran":""
  }
  const param = btoa(JSON.stringify({
    "invoice":`${nik}`,
    "amount":`${dataIuran.TOTAL}`,
    "items":`${items}`,
    "program":`${selectedProgram}`,
    "periode":`${periode}`,
    "kode_iuran":`${kodeIuran}`
  }))
  const iframe = `<iframe src='https://es.bpjsketenagakerjaan.go.id/pasarpolis/online_payment.bpjstk/${param}'></iframe>`
  const createMarkup = () => ({__html: iframe})
  return (
    <div dangerouslySetInnerHTML={createMarkup()}></div>
  )
}

export default Pembayaran



// WEBPACK FOOTER //
// ./src/component/Pembayaran/pembayaran.js